import React, { ReactNode } from 'react';
import BordTable from '../BordTable/BordTable';
import { IBordTableAction } from 'types/tableWithActions.types';
import { renderActions } from './utils/renderTable.util';
import './BordTableWithActions.scss';

interface BordTableWithActionsProps {
  title?: string | ReactNode;
  actions?: IBordTableAction[] | ReactNode[];
  headers: string[] | ReactNode[];
  data: any[][];
  tableClassName?: string;
}

const BordTableWithActions = ({
  title,
  actions,
  headers,
  data,
  tableClassName,
  ...rest
}: React.HTMLAttributes<HTMLElement> & BordTableWithActionsProps) => {
  return (
    <article {...rest} className={`bordTableWithActions ${rest.className || ''}`}>
      <header className="tableWithActionsHeader">
        {title && <h4 className="title">{title}</h4>}
        <div className="actions">{actions && actions.length > 0 && renderActions(actions)}</div>
      </header>
      <BordTable headers={headers} data={data} className={tableClassName} />
    </article>
  );
};

export default BordTableWithActions;
